"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetsList = void 0;
var React = require("react");
var core_1 = require("@athena-portal/core");
var WidgetComponentBase_1 = require("./WidgetComponentBase");
var DefaultLayout_1 = require("./layouts/DefaultLayout");
;
/**
 * Widgets list portal component
 *
 * @example
 * Renders all widgets which are configured to section 'dashboard'
 * ```JSX
 * <WidgetsList filter={WidgetsFilter.bySection('dashboard')} />
 * ```
 *
 * @example
 * Renders all widgets which are configured to section 'dashboard', person object is passed to each widget as properties
 * ```JSX
 * const personProvider = () => return { name: 'John Doe' };
 * <WidgetsList filter={WidgetsFilter.bySection('dashboard')} propsProvider={personProvider} />
 * ```
 *
 * @example
 * Renders all widgets which are configured to section 'dashboard', widgets are paged in chunks of 5
 * ```JSX
 * <WidgetsList filter={WidgetsFilter.bySection('dashboard')} itemsPerPage='5' />
 * ```
 *
 * @example
 * Renders all widgets which are configured to section 'dashboard', if no widgets configured, will render MyComponent instead
 * ```JSX
 * class MyComponent extends React.Component<{}, {}> { ... }
 *
 * <WidgetsList filter={WidgetsFilter.bySection('dashboard')} default={MyComponent} />
 * ```
 */
var WidgetsList = /** @class */ (function (_super) {
    __extends(WidgetsList, _super);
    function WidgetsList(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            widgets: _this.getFilteredOrDefault(_this.props.filter, _this.props.default)
        };
        _this.widgetsManager.addListener(core_1.WidgetsEvent.Change, _this.loadWidgets.bind(_this));
        return _this;
    }
    /**
     * Renders the widget
     */
    WidgetsList.prototype.render = function () {
        var _this = this;
        var layout = this.props.layout || DefaultLayout_1.DefaultLayout;
        var widgetsWithProps = this.state.widgets.map(function (widget) {
            return {
                widget: widget,
                props: Object.assign(widget.metadata || {}, _this.props.propsProvider ? _this.props.propsProvider() : {})
            };
        });
        return React.createElement(layout, __assign(__assign({}, this.props), { widgets: widgetsWithProps }));
    };
    /**
     * Loads widgets to show in the list
     */
    WidgetsList.prototype.loadWidgets = function () {
        this.setState({
            widgets: this.getFilteredOrDefault(this.props.filter, this.props.default)
        });
    };
    return WidgetsList;
}(WidgetComponentBase_1.WidgetComponentBase));
exports.WidgetsList = WidgetsList;
//# sourceMappingURL=WidgetsList.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/components/dist/widgets/WidgetsList.js
// module id = 2266
// module chunks = 0